// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? 'https://arkastra.fr/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:3000/api'),
  timeout: 10000, // Timeout après 10 secondes
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour le logging des erreurs
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response || error);
    return Promise.reject(error);
  }
);

export const getProjectsSummary = async (filters) => {
  try {
    const response = await api.get('/projets/plage_summary', { params: filters });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProjectDetails = async (projectId) => {
  try {
    const response = await api.get(`/projets/summary/${projectId}`);
    if (response && response.data) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

export const getProject = async (projectId) => {
  try {
    const response = await api.get(`/projets/${projectId}`);
    return response.data[0];
  } catch (error) {
    throw error;
  }
};

export const getArchitectDetails = async (architectId) => {
  try {
    console.log('API call to get architect details:', `/architects/${architectId}`);
    const response = await api.get(`/architects/${architectId}`);
    console.log('API response:', response);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const addProject = async (projectData) => {
  try {
    const response = await api.post('/projets', projectData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchProjects = async (query, limit = 5) => {
  try {
    const response = await api.get('/projets/search', {
      params: {
        q: query,
        limit
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const incrementProjectViews = async (projectId) => {
  try {
    const response = await api.post(`/projets/${projectId}/view`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMostViewedProjects = async (token) => {
  try {
    const response = await api.get('/projets/most-viewed', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
